<template>
  <div class="entry-form-thumbnails">
    <a
      class="entry-form-thumbnails__thumbnail"
      :class="{
        'entry-form-thumbnails__thumbnail--selected': i === selectedThumbnail
      }"
      :key="i"
      v-for="(url, i) in thumbnails"
      :tabindex="startTab + i + 1"
      href="#"
      @click.prevent="handleClick(i, url)"
      :style="{
        backgroundImage: `url(${url})`
      }">
    </a>
     <video class="entry-form-thumbnails__video" ref="video" muted>
      <source :src="src">
    </video>
    <canvas class="entry-form-thumbnails__canvas" ref="canvas"></canvas>
  </div>
</template>

<script>
import VideoThumbnails from './../mixins/video-thumbnails';

export default {
  name: 'entry-form-thumbnails',
  mixins: [VideoThumbnails],
  props: {
    startTab: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      selectedThumbnail: 0
    };
  },
  methods: {
    /**
     * emit the chosen thumbnail
     *
     * @param {string} url the url of the image clicked
     */
    handleClick(i, url) {
      console.log('click!');
      this.selectedThumbnail = i;
      this.$emit('click', url);
    }
  }
};
</script>

<style lang="scss">
.entry-form-thumbnails {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1 1 auto;
  &__canvas,
  &__video {
    display: none;
  }
  @include media(small){
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  &__thumbnail {
    display: block;
    position: relative;
     &:before {
      content: '';
      display: block;
      padding-bottom: percentage($number: $submission-thumbnail-ratio);
    }
    border-radius: $size-border-radius-entry-form-thumbnails-large;
    background-size: cover;
    background-position: center center;
    background-color: $color-background-entry-form-thumbnails-base;
    box-shadow: inset 0 0 0 $size-border-entry-form-thumbnails-base $color-border-entry-form-thumbnails-base;
    transition: border-color $time-global-transition-base linear;
    &--selected {
          box-shadow: inset 0 0 0 $size-border-entry-form-thumbnails-selected $color-border-entry-form-thumbnails-selected;
    }
    &:focus {
      outline: none;
          box-shadow: inset 0 0 0 $size-border-entry-form-thumbnails-selected $color-border-entry-form-thumbnails-selected;
    }
    @include global-media(small) {
      border-radius: $size-border-radius-entry-form-thumbnails-small;
    }
    @include media(small){
      width: 30%;
      margin-right: 5%;
      margin-bottom: 5%;
      &:nth-child(3n) {
        margin-right: 0%;
      }
    }
  }
  &__thumbnail-image {
    display: block;
    position: absolute;
    top: 0;
    width: 100%;
  }
}
</style>
